import ReactDOM from "react-dom/client";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import Loader from "./components/loader";
import { routeTree } from "./routeTree.gen";
import { queryClient, trpc } from "./utils/trpc";
import { ThemeProvider } from "./components/theme-provider";
import { Toaster } from "./components/ui/sonner";
import type { RouterAppContext } from "./utils/custom-types";
import { StrictMode } from "react";

declare module "@tanstack/react-router" {
	interface Register {
		router: ReturnType<typeof createRouter>;
	}
}

const contextObj: RouterAppContext = {
	trpc: trpc,
	queryClient: queryClient,
	session: undefined,
	currentWorkspace: undefined,
} 

export const router = createRouter({
	routeTree,
	defaultPreload: "intent",
	defaultPendingComponent: () => <Loader />,
	context: contextObj
});


function App() {
	return (
		<ThemeProvider
			attribute="class"
			defaultTheme="dark"
			disableTransitionOnChange
			storageKey="vite-ui-theme"
		>
			<QueryClientProvider client={queryClient}>
				<Toaster richColors />
				<RouterProvider router={router} />
			</QueryClientProvider>
		</ThemeProvider>
	);
}

const rootElement = document.getElementById("app");

if (!rootElement) {
	throw new Error("Root element not found");
}

if (!rootElement.innerHTML) {
	const root = ReactDOM.createRoot(rootElement);
	root.render(
		// <StrictMode>
			<App />
		// </StrictMode>
	);
}
